import { Component } from '@angular/core';

@Component({
  selector: 'lib-validate-details-component',
  standalone: true,
  providers: [],
  imports: [],
  templateUrl: './validate-details.component.html',
  styleUrl: './validate-details.component.scss',
})
export class ValidateDetailsComponent {}
